import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import LoRaSettingEdit from '../polling/pollingTopicEdit/LoRaSettingEdit';

export type SelectLoRaSettingDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
    dialogTitle: string;
};

export const SelectLoRaSettingDialog = (props: SelectLoRaSettingDialogProps) => {
    const { isOpen, onOK, onCancel, data, dialogTitle } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <LoRaSettingEdit onCancel={handleCancel} loRaSetting={data} onOK={(data) => handleUpdate(data)}></LoRaSettingEdit>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectLoRaSettingDialog;